/* Tippy */
import tippy from 'tippy.js';

// Tippy Html Content.
// reference: https://atomiks.github.io/tippyjs/v6/html-content/
// all props: https://atomiks.github.io/tippyjs/v6/all-props/

export function emTooltipHtmlContent(selector) {
	document.querySelectorAll(selector).forEach((item) => {
		tippy(item, {
			content(reference) {
				const id = reference.getAttribute('data-template');
				const template = document.getElementById(id);
				return template.innerHTML;
			},
			trigger: 'mouseenter click', // mouseenter, click, focus; manual.
			placement: 'bottom-start', // position where to appear tooltip
			allowHTML: true,
			interactive: true,
			arrow: false,
			// animation: 'scale',
			// duration: [ 250, 200 ],
			maxWidth: 'none',
			offset: [0, 0],
			// showOnInit: false, // to ease styling
		});
	});
}

document.addEventListener('DOMContentLoaded', emTooltipHtmlContent('[data-template]'));
